import React, { useState } from "react";
import {
  Box,
  Grid,
  Typography,
  useMediaQuery,
  Button,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Divider,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import InstagramIcon from "@mui/icons-material/Instagram";
import XIcon from "@mui/icons-material/X";
import FacebookIcon from "@mui/icons-material/Facebook";
import targetImage from "../images/MediaHeader.jpg";
import EmailSignupModal from "./EmailSignupModal";
import EventModal from "./EventModal";

const Media = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [eventOpen, setEventOpen] = useState(false);
  const [emailOpen, setEmailOpen] = useState(false);

  const mediaItems = [
    {
      title: "Sharif Hidayat Announces Congressional Run in GA-13",
      date: "July 22, 2025",
      onClick: () => setEventOpen(true),
    },
    {
      title: "Native Cowetan to run for Congress",
      date: "July 22, 2025",
      onClick: () =>
        window.open(
          "https://www.times-herald.com/news/native-cowetan-to-run-for-congress/article_10106385-e72e-4d6f-960a-c9a23288a976.html",
          "_blank"
        ),
    },
    // Add future media entries here like:
    // { title: 'Sharif Hidayat Wins Primary', date: 'September 10, 2025', onClick: () => setAnotherModal(true) }
  ];

  return (
    <Box sx={{ backgroundColor: "#FFFDF7!important" }}>
      {/* Header Section */}
      <Box
        sx={{
          backgroundImage: `radial-gradient(circle at 54% 98%, rgba(0, 55, 81, .4) 14%, #FFFe6 86%), url(${targetImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          height: "50vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          px: 2,
        }}
      >
        <Typography
          variant="h1"
          sx={{
            color: "white",
            fontWeight: "900!important",
            fontSize: {
              xs: "2.5rem",
              fontSize: isMobile ? "3rem!important" : "4rem!important",
              textTransform: "uppercase",
              fontWeight: "500!important",
            },
          }}
        >
          Media & Press
        </Typography>
      </Box>

      {/* Body Section */}
      <Box
        p={isMobile ? "16px" : "48px 96px 48px"}
        sx={{ borderTop: "5px solid #FFF" }}
      >
        <Grid container>
          <Grid item xs={12}>
            <Typography
              variant="h3"
              sx={{ mb: 3, fontWeight: 700, color: "#FFF" }}
            >
              Latest Releases
            </Typography>

            <List disablePadding>
              {mediaItems.map((item, index) => (
                <Box key={index}>
                  <ListItem disablePadding>
                    <ListItemButton onClick={item.onClick}>
                      <ListItemText
                        primary={item.title}
                        secondary={item.date}
                        primaryTypographyProps={{
                          sx: {
                            color: "white",
                            fontWeight: "bold",
                            fontSize: "1.1rem",
                          },
                        }}
                        secondaryTypographyProps={{
                          sx: {
                            color: "#aaa",
                            fontSize: "0.85rem",
                          },
                        }}
                      />
                    </ListItemButton>
                  </ListItem>
                  <Divider sx={{ backgroundColor: "#444" }} />
                </Box>
              ))}
            </List>
          </Grid>
        </Grid>
      </Box>

      {/* Modal */}
      <EventModal open={eventOpen} handleClose={() => setEventOpen(false)} />

      {/* Footer */}
      <footer>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
          mt={6}
          mb={4}
          spacing={2}
        >
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              sx={{ textTransform: "none", background: "#106cb7!important" }}
              onClick={() => setEmailOpen(true)}
            >
              Join Our Email List
            </Button>
          </Grid>
          <Grid item>
            <IconButton
              component="a"
              href="https://www.instagram.com/SharifHidayat320/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <InstagramIcon sx={{ color: "white" }} />
            </IconButton>
            <IconButton
              component="a"
              href="https://x.com/votesharif2026"
              target="_blank"
              rel="noopener noreferrer"
            >
              <XIcon sx={{ color: "white" }} />
            </IconButton>
            <IconButton
              component="a"
              href="https://facebook.com/VoteSharifDistrict7"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FacebookIcon sx={{ color: "white" }} />
            </IconButton>
          </Grid>
          <Grid
            item
            sx={{
              border: "1px solid white",
              padding: ".1rem .5rem !important",
              borderRadius: ".25rem!important",
            }}
          >
            <Typography
              variant="h6"
              sx={{ color: "white", fontSize: "1rem!important" }}
            >
              By authority: Friends of Sharif Hidayat; Cody Hidayat, Treasurer
            </Typography>
          </Grid>
        </Grid>
      </footer>
      <EmailSignupModal
        open={emailOpen}
        handleClose={() => setEmailOpen(false)}
      />
    </Box>
  );
};

export default Media;
